export { DealRegistrationsPage } from './src/deal-registrations-page';
